// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_bX","cardHeaderIcon__content":"c-e_bY"};